<template>
    <div class="navbar-toggler navbar-toggler-collapse hamburger align-self-end pe-3 pe-sm-45">
        <div class="navbar_left-side d-flex align-self-center">
            <button @click="closeMenu" class="navbar-toggler hamburger hamburger--spin hamburger--collapse position-relative d-flex align-items-center ms-4 ms-sm-3 ms-md-4 text-primary-hover h7 theme-dark is-active" type="button" aria-expanded="false" aria-label="Toggle navigation">
                <span class="hamburger-box hamburger-box--close">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>
    </div>
</template>
<script>

export default {
    props: [],
    data: function () {
        return {
        };
    },
    mounted() {
    },
    methods: {
        closeMenu() {
            this.$eventHub.$emit('closeMenu');
        }
    },
    beforeDestroy() {
    },
}
</script>

<style lang="scss" scoped>
    button:hover{
        opacity:.7
    }
</style>
